import { useEffect, useState } from 'react'
import { Keyboard, Platform } from 'react-native'

const isAndroid = Platform.OS === 'android'

export const useKeyboardShown = () => {
  const [shown, setShown] = useState(Keyboard.isVisible())

  useEffect(() => {
    const showSubscription = Keyboard.addListener(isAndroid ? 'keyboardDidShow' : 'keyboardWillShow', () =>
      setShown(true)
    )
    const hideSubscription = Keyboard.addListener(isAndroid ? 'keyboardDidHide' : 'keyboardWillHide', () =>
      setShown(false)
    )

    return () => {
      showSubscription.remove()
      hideSubscription.remove()
    }
  }, [])

  return shown
}
